import React from 'react';
import LoadingIndicator from '@wix/da-shared-react/pkg/LoadingIndicator';
import { PapiDeviation } from '@wix/da-types-papi';
import { useBestFittingImage, useImageLoader } from './hooks';
import { useDumboCommon } from '@wix/da-shared-react/pkg/DeviationViews/Dumbo/useDumbo';

interface Props {
  deviation: PapiDeviation;
  containerWidth: number;
  containerHeight: number;
  className: string;
}

const DeviationImageCoverView: React.FC<Props> = ({
  deviation,
  containerWidth,
  containerHeight,
  className,
}) => {
  const image = useBestFittingImage(deviation, containerWidth, containerHeight);
  const imageLoaded = useImageLoader(image && image.src);
  const DumboReturn = useDumboCommon({
    deviation,
    width: containerWidth,
    height: containerHeight,
  });

  if (!image) {
    return null;
  }

  if (DumboReturn) {
    return <div className={className}>{DumboReturn}</div>;
  }

  const isLargeEnough =
    image.width! >= containerWidth && image.height! >= containerHeight;

  return (
    <div className={className}>
      {imageLoaded ? (
        <div
          style={{
            backgroundImage: `url(${image.src})`,
            backgroundSize: isLargeEnough ? 'cover' : 'auto',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            width: '100%',
            height: '100%',
          }}
        />
      ) : (
        <LoadingIndicator />
      )}
    </div>
  );
};

export default React.memo(DeviationImageCoverView);
